/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo } from "react";

import { useFormContext } from "react-hook-form";

import { Accordion } from "@origin-digital/ods-core";

import UnderstandYourBill from "@/assets/understandYourBill.svg";
import {
  RadioGroupInput,
  RouterActions,
  StyledHeading,
  StyledText,
  TextInput,
} from "@/components";
import { StyledQuestion } from "@/components/StyledQuestion";
import { isSolarGenerationEmpty } from "@/features/SolarForm/utils/solarGenerationValidation";
import { useFieldValidation } from "@/hooks";

import { averageBill, solarGeneration } from "./content.json";

export const SolarGeneration = memo(
  ({
    batteryNextRoute,
    batteryBackRoute,
    degradedBatteryRoute,
  }: {
    batteryNextRoute: () => Promise<string>;
    batteryBackRoute: () => Promise<string>;
    degradedBatteryRoute: () => Promise<string>;
  }) => {
    const { register, getValues } = useFormContext();
    const { isValid } = useFieldValidation({
      fields: ["winterGeneration", "summerGeneration"],
    });

    const handleOnNextRoute = () =>
      isSolarGenerationEmpty(getValues)
        ? degradedBatteryRoute()
        : batteryNextRoute();

    return (
      <StyledQuestion data-id="solar-generation">
        <div>
          <StyledHeading>{solarGeneration.heading}</StyledHeading>
          <TextInput
            {...register("winterGeneration")}
            id={solarGeneration.winterGenerationInput.id}
            data-id={solarGeneration.winterGenerationInput.id}
            label={solarGeneration.winterGenerationInput.label}
          />
          <TextInput
            {...register("summerGeneration")}
            id={solarGeneration.summerGenerationInput.id}
            data-id={solarGeneration.summerGenerationInput.id}
            label={solarGeneration.summerGenerationInput.label}
          />
          <RadioGroupInput
            data-id={averageBill.duration.id}
            name="billFrequency"
            label={averageBill.duration.label}
            options={averageBill.duration.option}
          />
          <br />
          <br />
          <br />
          <Accordion
            id={solarGeneration.accordions.infoOnBill.id}
            summary={solarGeneration.accordions.infoOnBill.summary}
          >
            <StyledText>
              {solarGeneration.accordions.infoOnBill.firstParagraph}
            </StyledText>
            <br />
            <UnderstandYourBill width="100%" />
            <br />
            <StyledText>
              {solarGeneration.accordions.infoOnBill.secondParagraph}
            </StyledText>
          </Accordion>
          <Accordion
            id={solarGeneration.accordions.dontKnowInfo.id}
            summary={solarGeneration.accordions.dontKnowInfo.summary}
          >
            <StyledText>
              {solarGeneration.accordions.dontKnowInfo.firstParagraph}
            </StyledText>
          </Accordion>
        </div>
        <RouterActions
          onBackRoute={batteryBackRoute}
          onNextRoute={handleOnNextRoute}
          onNext={isValid}
        />
      </StyledQuestion>
    );
  }
);
